import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=2c2e97ad"
import script from "./VendorDetails.vue?vue&type=script&lang=js"
export * from "./VendorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2e97ad')) {
      api.createRecord('2c2e97ad', component.options)
    } else {
      api.reload('2c2e97ad', component.options)
    }
    module.hot.accept("./VendorDetails.vue?vue&type=template&id=2c2e97ad", function () {
      api.rerender('2c2e97ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Vendors/VendorDetails.vue"
export default component.exports